module.exports = __webpack_public_path__ + "media/images/locations/muenchenstein-523855ab905f1cc11a5b2dc978d35446.jpg";